import { Component } from '@angular/core';
import { membersuiteMiscellaneousProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Miscellaneous Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitemiscellaneousproduct-form',
    templateUrl: './membersuitemiscellaneousproduct.form.component.html'
})
export class membersuiteMiscellaneousProductFormComponent extends BaseFormComponent {
    public record!: membersuiteMiscellaneousProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

